var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TreeContainer",attrs:{"id":"treeContainer"}},[_c('lm-icon-button',{staticClass:"TreeClose",attrs:{"icon":"close"},on:{"click":_vm.close}}),_c('tree')],1)}
var staticRenderFns = []

export { render, staticRenderFns }